<template>
  <div class="send-tokens-modal">
    <ModalFullBackdrop class="fenif-test">
      <div class="container">
        <h3 class="modal-title" style="color: red">
          {{ $t("social_share.title") }}
        </h3>

        <ShareNetwork
          v-for="network in networks"
          :network="network.network"
          :key="network.network"
          :style="{ backgroundColor: network.color }"
          :url="sharing.url || ''"
          :title="sharing.title || ''"
          :description="sharing.description || ''"
          :quote="sharing.quote || ''"
          :hashtags="sharing.hashtags || ''"
          :twitterUser="sharing.twitterUser || ''"
        >
          <i :class="network.icon"></i>
          <span>{{ network.name }}</span>
        </ShareNetwork>
        <a
          @click="copyToClipboard"
          class="share-network-email"
          style="background-color: #333333"
        >
          <i class="fab fah fa-lg fas fa-link" aria-hidden="true"></i>
          <span>{{$t('social_share.copy_link')}}</span>
        </a>

        <div class="footer">
          <button class="cancel" @click="cancelHandler">
            {{ $t("tokens_modal.button_back") }}
          </button>
        </div>
      </div>
    </ModalFullBackdrop>
    <input
      type="hidden"
      :value="sharing.url"
      v-on:focus="$event.target.select()"
      ref="clipboard"
      readonly
    />
  </div>
</template>

<script>
import("public/js/lib/FontAwesomeKit"); // <--- importing FontAwesome icons

export default {
  props: {
    networks: {
      type: Array,
      default: () => [
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: "fab fah fa-lg fa-whatsapp",
          color: "#25d366",
        },
        {
          network: "telegram",
          name: "Telegram",
          icon: "fab fah fa-lg fa-telegram-plane",
          color: "#0088cc",
        },
        {
          network: "twitter",
          name: "Twitter",
          icon: "fab fah fa-lg fa-twitter",
          color: "#1da1f2",
        },
      ],
    },
    sharing: {
      type: Object,
      default: () => ({
        url: document.URL,
        title: "",
        description: "",
        quote: "",
      }),
    },
  },
  methods: {
    copyToClipboard() {
      this.$refs.clipboard.type = "text";
      try {
        this.$refs.clipboard.focus();
        document.execCommand("copy");
        this.cancelHandler();
      } catch (error) {
      } finally {
        this.$refs.clipboard.type = "hidden";
      }
    },
    cancelHandler() {
      this.$emit("cancel");
    },
  },
};
</script>

<style lang="scss" scoped>
.send-tokens-modal {
  & .picture {
    width: 5rem;
    height: 5rem;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-color: #ffffff;
    border-radius: 50%;
    border: 3px solid var(--pallete_main_color);
  }

  & .container {
    box-sizing: border-box;
    border-radius: 1rem;
    border: solid 2px #ccc;
    padding: 1rem;

    @media (min-width: 768px) {
      min-width: 350px;
    }

    & .modal-title {
      font-size: 1.5rem;
      text-transform: uppercase;
    }

    & h3 {
      margin: 0.5rem 0;
    }

    & .footer {
      display: flex;
      justify-content: flex-end;

      & button,
      .action {
        border-radius: 0.5rem;
        margin-left: 1rem;
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
        padding: 0.5rem 1rem;
      }

      & .action {
        padding: 0;
      }

      & .action > button {
        margin-left: 0;
      }

      & button.cancel {
        background-color: var(--pallete_main_color);
        color: var(--pallete_clear_text_color);
      }
    }
  }
}

h1 {
  text-align: center;
  margin: 50px 0 80px;
}
.share-network-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1000px;
  margin: auto;
}
a[class^="share-network-"] {
  flex: none;
  color: #ffffff;
  background-color: #333;
  border-radius: 3px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  cursor: pointer;
  margin: 0 10px 10px 0;
}
a[class^="share-network-"] .fah {
  background-color: rgba(0, 0, 0, 0.2);
  padding: 10px;
  flex: 0 1 auto;
}
a[class^="share-network-"] span {
  padding: 0 10px;
  flex: 1 1 0%;
  font-weight: 500;
}
</style>
